import { keyframes } from '@chakra-ui/react';

const transform = keyframes`
  from { opacity: 0 }
  to { opacity: 1 }
`;

export const fadeIn = (speed = '2s', delay = '2s'): string =>
  `${transform} ${speed} backwards ${delay}`;
